import script from "./DownloadAttribute.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadAttribute.vue?vue&type=script&setup=true&lang=js"

import "./DownloadAttribute.vue?vue&type=style&index=0&id=fd1805b6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd1805b6"]])

export default __exports__